package ru.it_mozaika.components


import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive

import mui.system.sx
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import react.dom.events.ChangeEvent

import react.dom.html.ReactHTML

import tanstack.react.table.renderHeader

import tanstack.table.core.Table
import web.cssom.Color
import web.cssom.pct
import web.cssom.px

import web.html.HTMLInputElement


external interface TableHeadProps: Props {
    var onSelectAllClick: (ChangeEvent<HTMLInputElement>) -> Unit
//    var order: String
//    var orderBy: String
    var numSelected: Int
    var rowCount: Int
    var table: Table<*>
    var onFilterClick: (String) -> Unit
    var propertiesWithFilters: List<String>
    var showCheckBox: Boolean?
    var showFilter: Boolean?

}
val tableHead = FC<TableHeadProps> { props ->

    TableHead {
        props.table.getHeaderGroups().forEach { headerGroups ->
            TableRow {
                if (props.showCheckBox == true|| props.showCheckBox == null || props.showCheckBox == undefined ) {
                    TableCell {
                        padding = TableCellPadding.checkbox
                        sx{
                            padding = 0.px
                        }
                        Checkbox {
                            color = CheckboxColor.secondary
                            indeterminate = props.numSelected > 0 && props.numSelected < props.rowCount
                            checked = props.rowCount > 0 && props.numSelected == props.rowCount
                            onChange = { event, checked -> props.onSelectAllClick(event) }
                            ariaLabel = "Выбрать все"
                        }

                    }
                }
                headerGroups.headers.forEach { header ->
                    TableCell {
                        key = header.id
                        align = TableCellAlign.center
                        scope = "row"
                        padding = TableCellPadding.normal
                        Stack{
                            direction = responsive(StackDirection.row)
                            spacing = responsive(2)
                            sx {
                                width = 100.pct
                            }
                            Typography{
                                variant = TypographyVariant.h4
                                + renderHeader(header)
                            }
                            if (props.showFilter == true) {
                                Tooltip {
                                    IconButton {
                                        if(props.propertiesWithFilters.contains(header.id)) {
                                            mui.icons.material.FilterList {
                                                onClick = {
                                                    println("Header id on filter click - ${header.id}")
                                                    props.onFilterClick(header.id)
                                                }
                                                sx{
                                                    color = Color("#FF0000")
                                                }
                                            }
                                        } else {
                                            mui.icons.material.FilterAlt{
                                                onClick = {
                                                    println("Header id on filter click - ${header.id}")
                                                    props.onFilterClick(header.id)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}